enum Events {
    SelectionChange = 'selection-change',
    ContentChange = 'content-change',
    Focus = 'focus',
    Blur = 'blur',
    All = '*',
}

export default Events;
